import { render, staticRenderFns } from "./TextImage4.vue?vue&type=template&id=3ea331ca&scoped=true"
import script from "./TextImage4.vue?vue&type=script&lang=js"
export * from "./TextImage4.vue?vue&type=script&lang=js"
import style0 from "./TextImage4.vue?vue&type=style&index=0&id=3ea331ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ea331ca",
  null
  
)

export default component.exports